module.exports = __webpack_public_path__ + "img/text.ffbbb87e.webp";